// /admin/integrations/api-docs — link a Swagger UI (Sprint 7).

export function ApiDocsPage() {
  return (
    <div>
      <h3 className="serif text-2xl mb-3" style={{ color: 'var(--ink)' }}>
        Documentazione API esterna
      </h3>
      <p className="text-sm mb-4" style={{ color: 'var(--mute)' }}>
        L'API REST v1 è documentata via OpenAPI / Swagger UI. Apri la documentazione in una nuova
        scheda e usa una API key (creata in "API Keys") nel campo "Authorize" per provare gli
        endpoint live.
      </p>
      <a
        href="/api/v1/docs"
        target="_blank"
        rel="noreferrer"
        className="rounded-md px-5 py-2 text-sm font-medium inline-block"
        style={{ background: 'var(--primary)', color: '#fff' }}
      >
        Apri /api/v1/docs ↗
      </a>

      <div className="mt-8 grid gap-3 text-sm" style={{ color: 'var(--ink)' }}>
        <div
          className="rounded-md border p-4"
          style={{ background: 'var(--paper)', borderColor: 'var(--line)' }}
        >
          <h4 className="serif text-xl mb-2">Autenticazione</h4>
          <p className="text-sm mb-1" style={{ color: 'var(--mute)' }}>
            Bearer token in header <code className="mono">Authorization: Bearer audq_...</code>
          </p>
        </div>

        <div
          className="rounded-md border p-4"
          style={{ background: 'var(--paper)', borderColor: 'var(--line)' }}
        >
          <h4 className="serif text-xl mb-2">Webhook signature</h4>
          <p className="text-sm" style={{ color: 'var(--mute)' }}>
            Pattern Stripe-like: <code className="mono">X-Audiq-Signature: sha256=&lt;hex&gt;</code>{' '}
            calcolato come{' '}
            <code className="mono">HMAC-SHA256(secret, "&lt;timestamp_ms&gt;.&lt;body&gt;")</code>.
            Il consumer verifica anche che <code className="mono">|now - timestamp| &lt; 300s</code>{' '}
            (anti-replay).
          </p>
        </div>

        <div
          className="rounded-md border p-4"
          style={{ background: 'var(--paper)', borderColor: 'var(--line)' }}
        >
          <h4 className="serif text-xl mb-2">Rate limiting</h4>
          <p className="text-sm" style={{ color: 'var(--mute)' }}>
            Configurabile per ogni API key (default 60 chiamate/min). Limit superato → HTTP 429.
          </p>
        </div>

        <div
          className="rounded-md border p-4"
          style={{ background: 'var(--paper)', borderColor: 'var(--line)' }}
        >
          <h4 className="serif text-xl mb-2">Retry webhook</h4>
          <p className="text-sm" style={{ color: 'var(--mute)' }}>
            7 tentativi con backoff esponenziale: 0s, 30s, 2min, 10min, 1h, 6h, 24h. Dopo 7
            fallimenti → status <code className="mono">exhausted</code>.
          </p>
        </div>
      </div>
    </div>
  );
}
